'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoSad = function IoSad(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm17.5 2.5c9.7 0 17.5 7.8 17.5 17.5s-7.8 17.5-17.5 17.5-17.5-7.8-17.5-17.5 7.8-17.5 17.5-17.5z m-8.7 20.3c0.2-0.4 0.3-0.9 1-1.2s1.1 0 1.5 0.3c0.3 0.2 0.8 0.2 1.2 0.1 0.2-0.1 0.5-0.3 0.7-0.5 0.5-0.6 0.3-1.3-0.3-1.7-1.2-0.7-2.4-1-3.9-0.5s-2.3 1.6-2.7 2.9c-0.2 0.7 0.2 1.3 0.9 1.5 0.2 0.1 0.5 0 0.8-0.1 0.4-0.2 0.7-0.4 0.8-0.8z m15.7 7c0.5-0.4 0.7-1.2 0.3-1.8-0.1-0.1-2.2-3-7.3-3s-7.2 2.9-7.3 3c-0.4 0.6-0.2 1.4 0.3 1.8 0.3 0.1 0.5 0.2 0.8 0.2 0.3 0 0.7-0.2 1-0.5 0 0 1.5-2 5.2-2s5.2 2 5.2 2c0.3 0.3 0.7 0.5 1.1 0.5 0.2 0 0.4-0.1 0.7-0.2z m3.3-6.1c0.7-0.2 1.1-0.8 0.9-1.5-0.4-1.3-1.1-2.4-2.7-2.9s-2.6-0.2-3.8 0.5c-0.6 0.4-0.9 1.1-0.4 1.7 0.2 0.2 0.5 0.4 0.7 0.5 0.4 0.1 0.9 0.1 1.2-0.1 0.4-0.3 0.8-0.5 1.5-0.3s0.8 0.8 1 1.2 0.4 0.6 0.8 0.8c0.3 0.1 0.6 0.2 0.8 0.1z' })
        )
    );
};

exports.default = IoSad;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/sad.js
// module id = 2434
// module chunks = 0